import Header from './components/Header';
import Home from './components/pages/Home';
import LandingPage from './components/pages/LandingPage';
import Footer from './components/Footer';
import Music from './components/pages/Music';
import KiwiHouse from './components/pages/KiwiHouse';
import QuietLodge from './components/pages/QuietLodge';
import Shows from './components/pages/Shows';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

function AppShell() {
  const { pathname } = useLocation();
  const hideChrome = pathname === '/' || pathname === '/quietlodge';

  return (
    <div className="min-h-screen flex flex-col">
      {!hideChrome && <Header />}
      <div className="grow flex flex-col max-w-full">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/lake-j" element={<Home />} />
          <Route path="/lake-j/music" element={<Music />} />
          <Route path="/lake-j/shows" element={<Shows />} />
          <Route path="/kiwi-house" element={<KiwiHouse />} />
          <Route path="/quietlodge" element={<QuietLodge />} />
        </Routes>
      </div>
      {!hideChrome && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
